import React from "react";
import { useAnimateInView } from "./useAnimateInView";
import CheckIcon from "../Assets/NoQueuesPage/icon_check.svg";
import ProgressBar from "../Assets/NoQueuesPage/progress-arrow.svg";
import SeemaMenCount from "../Components/SeemaMenCount";

const NoQueuesPage: React.FC = () => {
  const { ref, animateClassNames } = useAnimateInView();
  return (
    <div className={`eoy-page no-queues-page ${animateClassNames}`} ref={ref}>
      <h3 className="page-subtitle">No automations... yet</h3>
      <h2 className="page-title">
        Unlock faster and smarter remediation in two simple steps
      </h2>
      <div className="seem-progress-container">
        <img src={ProgressBar} alt="progress bar" className="progress-bar" />
        <div className="progress-item data-source-item">
          <div className="circle">
            <img
              src={CheckIcon}
              alt="check icon"
              className="progress-item-icon check-icon"
            />
          </div>
          <div className="progress-item-title">Data Sources</div>
        </div>
        <div className="progress-item integrations-item">
          <div className="circle">
            <span className="progress-item-icon">2</span>
          </div>
          <div className="progress-item-title">
            <span className="main">Connect</span>
            <div className="sub">Ticketing/Notification System</div>
          </div>
        </div>
        <div className="progress-item automations-item">
          <div className="circle">
            <span className="progress-item-icon">3</span>
          </div>
          <div className="progress-item-title">
            <span className="main">Create</span>
            <div className="sub">Automations</div>
          </div>
        </div>
      </div>
      <SeemaMenCount
        textComponent={
          <div className="text-content">
            Automate to <span>save time{`\n`}</span>
            And <span>resources</span>
          </div>
        }
        menCount={56}
      />
    </div>
  );
};

export default NoQueuesPage;
